import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import Image from 'components/Image';

import { solutionsStepsData } from 'utils/contentProvider';

import { Section } from './SolutionSteps.styled';

const SolutionSteps = ({ id, aboutPage, flyText, flyBoxImage }) => {
  const { length } = solutionsStepsData[id];
  const [percentDone, setPercentDone] = useState(0);
  const [currentStep, setCurrentStep] = useState(1);
  const [intervalID, setInvervalID] = useState(true);
  const featuresSection = useRef();
  const featuresSteps = useRef();

  function slideControlHandler(e) {
    setPercentDone((((e.target.dataset.id - 1) * 100) / length) * 1.1);
    clearInterval(intervalID);
  }

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setInvervalID(
        setInterval(() => {
          setPercentDone((percent) => (percent > 99 ? 0 : percent + 0.5));
        }, 100),
      );
    }
  }, []);

  useEffect(() => {
    setCurrentStep(Math.ceil((length * percentDone) / 100) || 1);
  }, [percentDone, length]);

  return (
    <Section
      ref={featuresSection}
      style={{
        backgroundColor: aboutPage ? '#0A090B' : '#181726',
      }}
      aboutPage={aboutPage}
    >
      <div className="container">
        <div className="project-steps-main" ref={featuresSteps}>
          <div className="project-slide-control">
            <div className="project-slide-control--bg" />
            <div
              className="project-slide-control--completed"
              style={{ height: (percentDone / 100) * (210 + 210 / length) }}
            />
            <div className="items">
              {Array.from({ length }, (v, k) => k + 1).map((i) => (
                <button
                  key={i}
                  type="button"
                  data-id={i}
                  onClick={slideControlHandler}
                  className={`single-slide-control${
                    percentDone + 100 / length > (i / length) * 100
                      ? ' active'
                      : ''
                    }`}
                >
                  <span />
                </button>
              ))}
            </div>
          </div>
          <div className="single-steps-slider">
            <div className="row flex-row-reverse">
              <div className="col-md-4">
                <div className="principle-img">
                  <span className="fly-text">{flyText}</span>
                  <span className="fly-box">
                    <Image src={flyBoxImage} alt={flyText} />
                  </span>
                </div>
              </div>
              <div className="col-md-7 offset-md-1">
                <div className="project-stp-content">
                  <div className="step-count">
                    <h5>{`0${currentStep}`}</h5>
                  </div>
                  <div className="step-desc">
                    <h3>{solutionsStepsData[id][currentStep - 1].title}</h3>
                    {solutionsStepsData[id][currentStep - 1].excerpt}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};

SolutionSteps.propTypes = {
  id: PropTypes.string.isRequired,
  aboutPage: PropTypes.bool,
  flyText: PropTypes.string,
  flyBoxImage: PropTypes.string,
};

export default SolutionSteps;
